<template>
  <div>
    <v-dialog
      persistent
      overlay-opacity="0.6"
      max-width="800"
      :value="publishingChangedDialog"
    >
      <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
          <v-flex md12>
            <v-card class="pa-0 ">
              <v-toolbar color="primary" dark>
                <v-app-bar-nav-icon
                  ><v-icon large>mdi-refresh</v-icon>
                </v-app-bar-nav-icon>

                <v-toolbar-title>Pubblicazione modifiche</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-row>
                  <v-col cols="11">
                    E' in corso la pubblicazione delle modifiche sul server
                    Aki Digital Solutions....
                  </v-col>
                  <v-col cols="1">
                    <v-progress-circular
                      :indeterminate="true"
                      :rotate="0"
                      :size="32"
                      :width="4"
                      color="light-blue"
                    ></v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-dialog
      persistent
      overlay-opacity="0.6"
      max-width="800"
      :value="mailConfigDialog"
    >
      <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
          <v-flex md12>
            <v-card class="pa-0 ">
              <v-toolbar color="primary" dark>
                <v-app-bar-nav-icon
                  ><v-icon large>mdi-mail</v-icon>
                </v-app-bar-nav-icon>

                <v-toolbar-title>Configurazione posta</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon @click="closeMailDialog" large>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-row>
                  <v-col>
                    Il sistema eGin supporta la configurazione della posta
                    tramite SMTP e POP/IMAP a seconda delle proprie preferenze.
                    Di seguito i parametri da utilizzare per configurare il
                    proprio client di posta:
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    Server posta in uscita SMTP:
                  </v-col>
                  <v-col> aki-digitalsolutions.com </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    Porta in uscita SMTP:
                  </v-col>
                  <v-col>
                    25 SSL
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    Server posta IMAP:
                  </v-col>
                  <v-col> aki-digitalsolutions.com </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    Porta IMAP:
                  </v-col>
                  <v-col>
                    993 SSL
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    Server in entrata POP:
                  </v-col>
                  <v-col> aki-digitalsolutions.com </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    La posta elettronica è anche visionabile dalla propria
                    interfaccia web all' indirizzo
                    <b>
                      <a
                        target="_blank"
                        :href="'https://webmail.aki-digitalsolutions.com'"
                        >webmail.aki-digitalsolutions.com</a
                      >
                    </b></v-col
                  >
                </v-row>

                <v-row class="text-center">
                  <v-col>
                    <v-btn
                      width="120"
                      @click="closeMailDialog()"
                      class="ma-2"
                      color="secondary"
                      >Chiudi</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-row class="form-title text-center" align="center" justify="center"
      ><h3>
        Benvenuto nella sua area personale di Aki Digital Solutions
        {{ config.appName }}. In questa sezione può visualizzare i suoi siti,
        modificarne i contenuti, o crearne uno nuovo.
      </h3></v-row
    >
    <v-row
      v-if="fetchingSites"
      class="form-title text-center"
      align="center"
      justify="center"
    >
      <v-progress-circular
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
      ></v-progress-circular>
    </v-row>

    <v-card class="pa-0 ma-4" v-for="i in sites" :key="i.id">
      <v-toolbar color="primary" dark>
        <v-app-bar-nav-icon><v-icon large>mdi-web</v-icon> </v-app-bar-nav-icon>

        <v-toolbar-title>{{ i.domain }}</v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row dense>
          <v-col cols="8"
            >Piano dominio:
            <span class="green--text">{{
              i.feature == "base"
                ? "Base"
                : i.feature == "premium"
                ? "Premium"
                : "Deluxe"
            }}</span>
          </v-col>
          <v-col></v-col>
          <v-col>
            <v-btn
              @click="showMailConfig(i)"
              color="orange"
              class="ma-2 white--text"
            >
              Configurazione posta
              <v-icon right dark>
                mdi-mail
              </v-icon>
            </v-btn></v-col
          >
        </v-row>

        <v-row dense>
          <v-col cols="8"
            >Stato dominio:
            <span v-if="i.finalized && !i.domain_expire" class="green--text"
              >Attivo</span
            >
            <span
              v-if="
                !i.finalized &&
                  !i.domain_expire &&
                  !i.failed_error &&
                  !i.aws_operation_id
              "
              class="orange--text"
              >In attesa del pagamento con bonifico</span
            >
            <span
              v-if="
                !i.finalized &&
                  !i.domain_expire &&
                  !i.failed_error &&
                  i.aws_operation_id
              "
              class="orange--text"
              >Registrazione in corso</span
            >
            <span v-if="!i.finalized && i.failed_error" class="red--text"
              >Errore. Contattare l'assistenza</span
            >

            <span v-if="i.domain_expire" class="red--text">Disattivato</span>
          </v-col>
          <v-col></v-col>
          <v-col
            ><v-btn
              @click="migrationCode()"
              color="blue-grey"
              class="ma-2 white--text"
            >
              Codice migrazione
              <v-icon right dark>
                mdi-transit-transfer
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="8"></v-col>
          <v-col></v-col>
          <v-col>
            <v-btn
              v-if="false"
              @click="extendPlan()"
              color="blue-grey"
              class="ma-2 white--text"
            >
              Estendi piano
              <v-icon right dark>
                mdi-skip-next-circle-outline
              </v-icon>
            </v-btn></v-col
          >
        </v-row>

        <v-row dense>
          <v-col cols="8"
            >Stato pagamenti:
            <span v-if="!i.aws_operation_id" class="red--text"
              >Pagamento non ancora effettuato</span
            >

            <span v-if="i.aws_operation_id" class="green--text">
              {{
                i.domain_expire
                  ? "Valido fino al " + i.domain_expire
                  : "Nessuna scadenza"
              }}</span
            ></v-col
          >
          <v-col></v-col
          ><v-col
            ><v-btn
              v-if="false"
              @click="renewPayment()"
              color="#b083a8"
              class="ma-2 white--text"
            >
              Rinnova pagamento
              <v-icon right dark>
                mdi-currency-eur
              </v-icon>
            </v-btn></v-col
          >
        </v-row>

        <v-row class="text-center" align="center" justify="center">
          <v-col
            ><v-btn color="#b083a8" class="white--text" @click="previewSite(i)">
              Anteprima sito
            </v-btn></v-col
          ><v-col
            ><v-btn class="ml-2" color="primary" dark @click="modifySite(i)">
              Modifica sito
            </v-btn></v-col
          ><v-col
            ><v-btn
              class="ml-2 white--text"
              color="orange"
              @click="publishChanges(i)"
            >
              Pubblica modifiche
            </v-btn></v-col
          >
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.form-spacer {
  height: 30px;
}
</style>

<script>
import sites from "../apis/sites";
import wizards from "../apis/wizard";
import config from "../config";

export default {
  data() {
    return {
      config: config,
      sites: [],
      fetchingSites: false,
      mailConfigDialog: false,
      mailConfigDialogContext: { domain: "" },
      publishingChangedDialog: false,
    };
  },

  mounted() {
    this.fetchingSites = true;
    sites
      .fetchSitesForAccount()
      .then((res) => {
        this.sites = res.sites;
        this.fetchingSites = false;
        this.$store.state.wizard.meta = {};
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    closeMailDialog() {
      this.mailConfigDialog = false;
    },

    showMailConfig(context) {
      this.mailConfigDialogContext = context;
      this.mailConfigDialog = true;
    },

    publishChanges(s) {
      this.publishingChangedDialog = true;
      sites
        .publish({
          site: s,
          plesk_domain_id: s.plesk_domain_id,
        })
        .then(() => {
          this.publishingChangedDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.publishingChangedDialog = false;
        });
    },

    previewSite(s) {
      let thisURl = window.location.origin;
      let url =
        thisURl +
        "/sites/" +
        config.appPath +
        "/" +
        (s.feature == "base" ? "base" : "premium") +
        "?s=" +
        s.meta_id;
      window.open(url.replace("/deluxe", "/premium"));
    },

    modifySite(s) {
      // Collect all site metadata
      wizards
        .collectMeta(s.meta_id)
        .then((res) => {
          this.$store.state.wizard.meta = res;
          this.$store.state.editing = s.meta_id;
          this.$store.state.editing_step = 1;
          this.$router.push("/editor");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    extendPlan() {},

    migrationCode() {},

    renewPayment() {},
  },
};
</script>
